var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8475 7.24346C23.6331 6.94763 18.5245 0 11.9999 0C5.4753 0 0.36647 6.94763 0.152297 7.24317C-0.0507658 7.52382 -0.0507658 7.90447 0.152297 8.18512C0.36647 8.48094 5.4753 15.4286 11.9999 15.4286C18.5245 15.4286 23.6331 8.48089 23.8475 8.18535C24.0508 7.90475 24.0508 7.52382 23.8475 7.24346ZM11.9999 13.8325C7.19383 13.8325 3.03127 9.22124 1.79907 7.71374C3.02968 6.20492 7.18352 1.59605 11.9999 1.59605C16.8057 1.59605 20.968 6.20653 22.2007 7.71483C20.9701 9.2236 16.8163 13.8325 11.9999 13.8325Z",
    id: "Shape",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71429 0C2.11488 0 0 2.11488 0 4.71429C0 7.31369 2.11488 9.42857 4.71429 9.42857C7.31369 9.42857 9.42857 7.31369 9.42857 4.71429C9.42857 2.11488 7.31369 0 4.71429 0ZM4.71429 7.85711C2.98125 7.85711 1.57146 6.44727 1.57146 4.71429C1.57146 2.9813 2.9813 1.57146 4.71429 1.57146C6.44727 1.57146 7.85711 2.9813 7.85711 4.71429C7.85711 6.44727 6.44732 7.85711 4.71429 7.85711Z",
    transform: "translate(6.857143 2.5714285)",
    id: "Shape",
    fill: "#000000",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.25542dcf23bf501daf3d46b3112deb79.svg";
export { ForwardRef as ReactComponent };